import React from 'react';
import doctor from '../../assets/doctorAbout.png';
import { Link } from 'react-router';

const IntroSection = ({title, about}) => {
  return (
    <div className="relative min-h-[600px] h-screen w-full transform -translate-y-8">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src={doctor} 
          alt="Dental office interior with staff" 
          className="w-full h-full object-cover"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative max-w-6xl mx-auto px-6 h-screen" style={{display: 'flex', alignItems: 'center'}}>
        <div className="max-w-2xl space-y-6">
          <span className="text-sm font-medium text-white/90 tracking-wider">
            {title}
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white leading-tight">
            {about}
          </h1>

          <div className="space-y-4 pt-4">
            <Link 
              to='/schedule-appointment'
              className="bg-lime-400 text-gray-800 hover:bg-lime-500 transition-colors font-bold rounded px-8 py-3 duration-200"
              style={{display: 'block', width: 'fit-content'}}
              >
              BOOK ONLINE
            </Link>
            
            <div className="block">
              <a href="tel:8401749379" className="font-bold text-white hover:text-yellow-200 transition-colors">
                CALL +91 84017 49379
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSection;